<template>
  <div class="original-exam">
    <v-base-card>
      <template v-slot:heading>
        オリジナルテスト作成条件
      </template>

      <template v-slot:content>
        <!-- 教科選択 -->
        <v-section-panel useBreak>
          <template v-slot:title> 1.教科を選択してください。</template>
          <template v-slot:content>
            <v-choice-subjects/>
          </template>
        </v-section-panel>

        <!-- 学年選択 -->
        <v-section-panel useBreak v-if="!$store.getters.selectedSubjectHasChild">
          <template v-slot:title> 2.学年を選択してください。</template>
          <template v-slot:content>
            <v-choice-grades
              :selected="$store.state.top.selectedGrade.id"
              @onChange="changeGrade"
            />
          </template>
        </v-section-panel>

        <!-- 学年以降の選択肢は別コンポーネントへ -->
        <!-- 社会を選択してたらタブあり -->
        <template v-if="showShakaiTabs">
          <p class="attention__message">※上で複数の領域を選択した場合，下のタブを切り替えて設定を行ってください。</p>
          <v-tab-type-setting-options class="mb-4" />
        </template>
        <!-- 社会以外はタブなし-->
        <v-type-setting-options v-else-if="!$store.getters.selectedSubjectHasChild"/>

        <!-- 確認ボタン -->
        <!-- <v-btn color="secondary" to="/change">確認</v-btn> -->
        <v-btn color="secondary" @click="confirm">確認</v-btn>
      </template>

    </v-base-card>
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoiceSubjects from '@/components/molecules/ChoiceSubjects'
import VChoiceGrades from '@/components/molecules/ChoiceGrades'
import VTypeSettingOptions from '@/components/organizms/TypeSettingOptions'
import VTabTypeSettingOptions from '@/components/organizms/TabTypeSettingOptions'
import config from "../../config"

export default {
  components: {
    VBaseCard,
    VSectionPanel,
    VTypeSettingOptions,
    VTabTypeSettingOptions,
    VChoiceSubjects,
    VChoiceGrades,
  },

  computed: {
    showShakaiTabs() {
      return this.$store.getters.selectedSubjectHasChild
        && this.$store.state.top.selectedShakaiOptions.length !== 0
    },
  },

  methods: {
    changeGrade(event) {
      this.$store.commit(
        'setSelectedGrade',
        {
          grade: this.$store.state.master.allGrades
            ? this.$store.state.master.allGrades.find(grade => grade.id === event)
            : null
        }
      )
    },
    async confirm() {
      const res = await this.$store.dispatch('validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else {
        this.$app.$refs.loading.open({type: 'print', message: '問題検索中です'})
        const gradeId = this.$store.state.top.selectedGrade?.id
        const subjectId = this.$store.state.top.selectedSubject?.id
        const conditions = this.$store.getters.sendApiParams.reduce((accumulator, condition) => {
          const selectedSubject = this.$store.state.master.allSubjects.find(x => x.code == condition.code)
          accumulator.push({
            grade_id: this.$store.getters.selectedSubjectHasChild ? null : Number(gradeId),
            subject_id: Number(selectedSubject?.id),
            publisher_id: Number(condition.selectedPublisher?.id),
            page_ranges: config.publisherNoneSubjecs.includes(condition.code) ? [] : condition.publisherPages.map(page => { return { start: Number(page.start), end: Number(page.end) } }),
            question_num: Number(condition.questionNum),
            difficulty_id: condition.selectedDifficulty ? Number(condition.selectedDifficulty.id) : 9,
            writing_question_flag: condition.selectedWritingQuestion,
            listening_flag: condition.selectedUseListening,
            before_grade_flag: condition.useBeforeGrade,
            selected_max_point_value: this.$store.state.top.selectedMaxPointValue,
            selected_max_point: this.$store.state.top.selectedMaxPoint,
            athletic_event_ids: condition.selectedAthleticEvents.map(athletic => Number(athletic.id)),
          })
          return accumulator
        }, [])

        const subjectTeacherId = this.$store.state.top.subjectTeachers.find(subjectTeacher => {
            return (subjectTeacher.grade.id === gradeId && subjectTeacher.subject.id === subjectId)
          })?.id
        const params = {
          sheet: {
            id: this.$store.state.sheet.sheetContentPages?.id,
            subject_teacher_id: subjectTeacherId,
            step: config.step.REPLACE_CONTENT, // STEP（再開時に必要）
            search_conditions: conditions      // 検索条件保存用（再開時に必要）
          },
          conditions: conditions
        }

        await this.$store.dispatch('sheet/getSheetContents', params)
          .then(() => {
            this.$app.$refs.loading.close()
            this.$router.push('/teacher/change')
          })
          .catch(() => {
            this.$app.$refs.loading.close()
          })

        this.$store.commit('sheet/setSheetSearchCondition', {
          sheetSearchCondition: conditions
        })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.choice-material__attention
  color #747474

.attention__message
  color #FF0000
</style>
